import { render, staticRenderFns } from "./DeliverySlots.vue?vue&type=template&id=85c3ce56&scoped=true"
import script from "./DeliverySlots.vue?vue&type=script&lang=js"
export * from "./DeliverySlots.vue?vue&type=script&lang=js"
import style0 from "./DeliverySlots.vue?vue&type=style&index=0&id=85c3ce56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c3ce56",
  null
  
)

export default component.exports